<template>
  <div
    class="d-flex flex-column page-title-box"
    v-if="(listLastValue !== '' && $route.meta?.hideTitle !== true) || breadcrumbList.length > 1"
  >
    <div class="page-title-right d-block">
      <ol class="breadcrumb m-0" v-if="breadcrumbList.length > 1">
        <li
          v-for="(item, index) in breadcrumbList"
          :key="index"
          class="breadcrumb-item"
          :class="{ active: isActive(index) }"
        >
          <template v-if="isActive(index)">
            {{ resolveBreadcrumbName(item.label) }}
          </template>
          <router-link v-else-if="item.name" :to="{ name: item.name, params: item.params }">
            {{ resolveBreadcrumbName(item.label) }}
          </router-link>
          <template v-else>
            {{ resolveBreadcrumbName(item.label) }}
          </template>
        </li>
      </ol>
      <h4 :class="{ 'fw-bold mb-3 mt-0': listLastValue !== '' }" v-if="$route.meta?.hideTitle !== true">
        {{ listLastValue }}
      </h4>
    </div>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { size, last, isUndefined } from 'lodash'

import { useBreadcrumbStore } from '@/stores/retailer/breadcrumb.js'

export default {
  data() {
    return {
      breadcrumbList: []
    }
  },
  setup() {
    const breadcrumbStore = useBreadcrumbStore()
    const { title } = storeToRefs(breadcrumbStore)

    return { title }
  },
  created() {
    if (this.$route.matched.length > 1) {
      this.$route.matched.forEach(route => {
        if (size(route.meta.breadcrumb) > 0) {
          if (route.meta.breadcrumb.parentLabel) {
            this.breadcrumbList.push({
              label: route.meta.breadcrumb.parentLabel
            })
          }
          if (route.meta.breadcrumb.parent) {
            const rawParent = route.meta.breadcrumb.parent
            const parent = typeof rawParent === 'function' ? rawParent(this.$route) : { name: rawParent }
            const parentRoute = this.$router.resolve({ name: parent.name, params: parent.params })

            this.breadcrumbList.push({
              label: parentRoute.meta.breadcrumb.name,
              name: last(parentRoute.matched).name,
              params: parent.params ?? parentRoute.params
            })
          }
        }
        if (isUndefined(route.name)) {
          //
        } else {
          this.breadcrumbList.push({
            label: route.meta.breadcrumb.name,
            name: route.name
          })
        }
      })
    } else {
      if (this.$route.meta.breadcrumb.parentLabel) {
        this.breadcrumbList.push({
          label: this.$route.meta.breadcrumb.parentLabel
        })
      }
      this.breadcrumbList.push({
        label: this.$route.meta.breadcrumb.name,
        name: this.$route.name
      })
    }
    const pageTitles = this.breadcrumbList.map(item => this.resolveBreadcrumbName(item.label))
    const mergedPageTitles = pageTitles.reduce((previousUrl, currentUrl) => `${currentUrl} / ${previousUrl}`)
    document.title = mergedPageTitles
  },
  watch: {
    $route: {
      handler(newValue, _oldValue) {
        this.breadcrumbList = []

        if (newValue.meta.breadcrumb.parentLabel) {
          this.breadcrumbList.push({
            label: newValue.meta.breadcrumb.parentLabel
          })
        }

        this.breadcrumbList.push({
          label: newValue.meta.breadcrumb.name,
          name: newValue.name
        })
      },
      deep: true
    }
  },
  methods: {
    resolveBreadcrumbName(name) {
      return typeof name === 'function' ? name() : name
    },
    isActive(index) {
      if (index === this.breadcrumbList.length - 1) {
        return true
      }

      return false
    }
  },
  computed: {
    listLastValue() {
      const title =
        this.title !== null
          ? this.title
          : this.resolveBreadcrumbName(this.breadcrumbList[this.breadcrumbList.length - 1].label)

      return title !== this.$t('router.dashboard') ? title : ''
    }
  }
}
</script>
